import {useLazyQuery, useMutation, useQuery} from "@apollo/client";
import {useParams} from "react-router-dom";
import {GET_PRIVACY_POLICY} from "../../../graphql/queries/policy.query";
import {useEffect, useState} from "react";
import {IonCheckbox, IonCol, IonRow, IonSkeletonText} from "@ionic/react";
import {GET_QUOTE_BY_TOKEN} from "../../../graphql/queries/quote.query";
import {
  getNameFromUrl,
  getSignedUrlForAccessToken,
} from "../../../lib/utils/common.utils";
import {
  UPDATE_ESTIMATE_AS_READ_BY_ACCESS_TOKEN,
  UPDATE_ESTIMATE_STATUS_BY_ACCESS_TOKEN,
} from "../../../graphql/mutations/quote.mutation";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import Loading from "../../../components/Loading";

const AcceptEstimate = () => {
  const {token} = useParams<any>();
  const privacyType = "order";

  const [quote, setQuote] = useState<any>({});
  const [message, setMessage] = useState<string>(
    "Il preventivo richiesto è scaduto o il link non è più valido."
  );
  const [title, setTitle] = useState<string>(
    "Preventivo scaduto o link non valido"
  );
  const [userDocuments, setUserDocuments] = useState<string[]>([]);
  const [adminDocuments, setAdminDocuments] = useState<string[]>([]);
  const [expired, setExpired] = useState(true);

  const [privacyPolicy, setPrivacyPolicy] = useState({
    title: "",
    body: "",
    footer: "",
  });

  const [checked, setChecked] = useState(false);

  const [updateEstimateStatus] = useMutation(
    UPDATE_ESTIMATE_AS_READ_BY_ACCESS_TOKEN,
    {
      onCompleted(data) {
        const resp = data?.updateStatusOfUnreadEstimateUsingAccessToken;
        if (resp.errors && resp.errors.length > 0) {
          setExpired(true);
        }
      },
    }
  );

  const [acceptEstimateMutation, {loading: acceptEstimateMutationLoading}] =
    useMutation(UPDATE_ESTIMATE_STATUS_BY_ACCESS_TOKEN, {
      onCompleted(data) {
        const resp = data.updateEstimateByAccessToken;
        if (resp.errors && resp.errors.length > 0) {
          toast.error(resp.errors[0].message);
          setExpired(true);
        } else {
          setExpired(true);
          setTitle("Preventivo accettato");
          setMessage("Il preventivo è stato accettato con successo.");
        }
      },
    });
  const {loading: getPrivacyLoading} = useQuery(GET_PRIVACY_POLICY, {
    fetchPolicy: "cache-and-network",
    variables: {
      type: privacyType,
    },
    onCompleted(data) {
      setPrivacyPolicy(data.getPrivacyPolicy.data);
    },
  });

  const [fetchQuotes, {loading}] = useLazyQuery(GET_QUOTE_BY_TOKEN, {
    variables: {
      accessToken: token,
    },
    onCompleted: async (data) => {
      if (
        data.getRequestedEstimateByAccessToken?.errors &&
        data?.getRequestedEstimateByAccessToken.errors.length
      ) {
        // toast.error(data.getRequestedEstimateByAccessToken.errors[0].message);
      } else {
        setExpired(false);
        const dataItem = data?.getRequestedEstimateByAccessToken?.data;
        setQuote(dataItem);

        // Marking the quote as read, if it is unread
        if (dataItem.status === "unread") {
          updateEstimateStatus({
            variables: {
              accessToken: token,
            },
          });
        }
        if (dataItem.status === "accepted") {
          setExpired(true);
          setTitle("Preventivo già accettato");
          setMessage("Il preventivo è già stato accettato.");
          return;
        }

        const userDocs = dataItem?.documents;
        // getting signed url for user documents
        if (Array.isArray(userDocs)) {
          const signedDocs: string[] = [];
          for (const unsignedDoc of userDocs) {
            const signedUrl = await getSignedUrlForAccessToken(
              unsignedDoc,
              token
            );
            signedDocs.push(signedUrl);
          }
          setUserDocuments(signedDocs);
        }

        const adminDocs = dataItem?.estimateResponse?.documents;
        // getting signed url for admin documents
        if (Array.isArray(adminDocs)) {
          console.log("adminDocs", adminDocs);
          const signedDocs: string[] = [];
          for (const unsignedDoc of adminDocs) {
            const signedUrl = await getSignedUrlForAccessToken(
              unsignedDoc,
              token
            );
            signedDocs.push(signedUrl);
          }
          setAdminDocuments(signedDocs);
        }
      }
    },
  });

  useEffect(() => {
    fetchQuotes();
  }, []);

  if (loading || acceptEstimateMutationLoading) return <Loading />;

  return (
    <div className="app-container">
      {!expired ? (
        <>
          <div className="container-with-space">
            <div
              className="app-page-title"
              style={{
                marginBottom: "10px",
                textAlign: "center",
              }}
            >
              <h1>Dettagli preventivo</h1>
            </div>
            <div className="order-detail-container">
              <div className="order-detail-header">
                <div className="order-detail-title">
                  <span>Numero preventivo: </span>
                  <span className="order-detail-number">{quote?.id}</span>
                </div>
                <div>
                  <div className="flex">
                    <div></div>
                    <div className="order-expiry-date">
                      <span>Scadenza preventivo:</span>
                      <span className="order-expires-at">
                        {quote.estimateResponse?.expiresAt ? (
                          <span>
                            {dayjs(quote.estimateResponse?.expiresAt).format(
                              "DD/MM/YYYY"
                            )}
                          </span>
                        ) : (
                          <span>nessuna scadenza</span>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="order-detail-customer">
                <IonRow>
                  <IonCol size="12" sizeMd="6" className="ion-no-padding">
                    <p className="order-detail-title">
                      Dettaglio richiesta cliente:
                    </p>
                    <span>{quote.description} </span>
                  </IonCol>
                  <IonCol size="12" sizeMd="6" className="ion-no-padding">
                    <p className="order-detail-title">Allegati caricati:</p>
                    <PreventiviDetailDocument documents={userDocuments} />
                  </IonCol>
                </IonRow>
              </div>

              {quote.status !== "notVerified" && (
                <div className="order-detail-cos">
                  <IonRow>
                    <IonCol size="12" sizeMd="6" className="ion-no-padding">
                      <p className="order-detail-title">
                        Note aggiuntive di COS:
                      </p>
                      <span>{quote.estimateResponse?.description}</span>
                    </IonCol>
                    <IonCol size="12" sizeMd="6" className="ion-no-padding">
                      <p className="order-detail-title">
                        Allegati caricati da COS:
                      </p>
                      <PreventiviDetailDocument documents={adminDocuments} />
                    </IonCol>
                  </IonRow>
                </div>
              )}
            </div>
          </div>
          <div className="attesa-modal">
            <p className="attesa-policy-modal-title attesa-modal-title">
              {privacyPolicy?.title}
            </p>
            <div
              className="attesa-policy-modal-body"
              dangerouslySetInnerHTML={{__html: privacyPolicy.body}}
            />
            <div className="attesa-policy-footer-with-checkbox">
              <div className="attesa-policy-footer-checkbox">
                <IonCheckbox
                  color="primary"
                  slot="start"
                  checked={checked}
                  onIonChange={(e) => {
                    setChecked(e.detail.checked);
                  }}
                />
              </div>
              {getPrivacyLoading ? (
                //skeleton
                <div
                  className="attesa-policy-modal-footer"
                  style={{width: "100%"}}
                >
                  <IonSkeletonText animated style={{width: "100%"}} />
                  <IonSkeletonText animated style={{width: "100%"}} />
                  <IonSkeletonText animated style={{width: "100%"}} />
                </div>
              ) : (
                <div
                  className="attesa-policy-modal-footer"
                  dangerouslySetInnerHTML={{
                    __html: privacyPolicy.footer.replace(
                      /{{url}}/gi,
                      `${window.location.origin}/privacy-policy/${privacyType}`
                    ),
                  }}
                />
              )}
            </div>
            <div className="attesa-policy-buttons attesa-button-font">
              <button
                className="attesa-button-save"
                disabled={!checked}
                onClick={() => {
                  if (!token) return;
                  acceptEstimateMutation({
                    variables: {
                      accessToken: token,
                    },
                  });
                }}
              >
                ACCETTA PREVENTIVO
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="app-page-wrapper flex-center">
          <div className="attesa-modal">
            <p className="attesa-policy-modal-title attesa-modal-title">
              {title}
            </p>
            <div className="attesa-policy-modal-body">
              <p>{message}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AcceptEstimate;

interface IPDProps {
  documents: string[];
}
function PreventiviDetailDocument(props: IPDProps) {
  if (props.documents.length < 1) return <span>Nessuno</span>;

  return (
    <div className="order-detail-container">
      {props.documents.map((doc: string, index: number) => (
        <div key={index} className="order-detail-document">
          <a href={doc} target="_blank" rel="noopener noreferrer">
            <span>{(index + 1).toString().padStart(2, "00")}</span>
            <span> - {getNameFromUrl(doc)}</span>
          </a>
        </div>
      ))}
    </div>
  );
}
